import i18next from "i18next";

import { createColumn } from "../../components/Table";
import { getWardLabel } from "../../utils/wardLabel";

export const protocolListColumns = [
  createColumn({
    keyName: "protocolName",
    header: () => i18next.t("protocols_columns_name"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
  createColumn({
    keyName: "actionNames",
    header: () => i18next.t("protocols_columns_actions"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
  createColumn({
    keyName: "wardName",
    header: () => getWardLabel().singular,
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "published",
    header: () => i18next.t("protocols_columns_published"),
    cell: (info) => info.renderValue(),
    size: 50,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 50,
  }),
];
